import type { MouseEvent as ReactMouseEvent } from "react";
import clsx from "clsx";
import { Eye, EyeOff } from "lucide-react";
import { Button } from "components/common/Button";
import type { GroupVisibilityToggleButtonProps } from "./types";

export const GroupVisibilityToggleButton = ({
  isHidden,
  onToggle,
  title,
}: GroupVisibilityToggleButtonProps) => {
  const Icon = isHidden ? EyeOff : Eye;

  const handleClick = (event: ReactMouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    onToggle();
  };

  return (
    <Button
      variant="text"
      size="sm"
      onClick={handleClick}
      title={title}
      className={clsx(
        "!p-0",
        isHidden
          ? "!text-gray-400 hover:!text-gray-600"
          : "!text-blue-600 hover:!text-blue-700",
      )}
    >
      <Icon size={20} />
    </Button>
  );
};
